import React from "react"
import {Route, Routes} from "react-router-dom";
import {IncidentListPage} from "@/pages/incidents/incident-list";
import {IncidentMapPage} from "@/pages/incidents/incident-map";
import {BodyWrapper} from "@/components/body-wrapper";


export function IncidentRoutes() {
    return (
        <BodyWrapper>
            <Routes>
                <Route
                    path="/"
                    element={
                        <IncidentListPage/>
                    }
                />
                <Route
                    path="/map"
                    element={
                        <IncidentMapPage/>
                    }
                />
            </Routes>
        </BodyWrapper>
    )
}
